import { DatePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivitiesByDateRangeDto } from './activities-by-date-range-dto';
import { ActivityHistoryDetail } from './activity-history-detail';
import { ActivityFacet } from './activity-facet';

@Injectable()
export class ActivityCalendarService {
  constructor(private httpClient: HttpClient, private datePipe: DatePipe) {}

  getRangeActivityHistory(startDate: Date, endDate: Date, activityTypes: number[]): Observable<ActivitiesByDateRangeDto> {
    if (!startDate || !endDate || !activityTypes) {
      throw new Error('Types, Start and End dates need to be defined.');
    }
    const fromDate = this.datePipe.transform(startDate, 'MMddyyyy');
    const toDate = this.datePipe.transform(endDate, 'MMddyyyy');
    const stringifiedActivityTypes = activityTypes.toString();
    const params: HttpParams = new HttpParams().set('fromDate', fromDate).set('toDate', toDate).set('types', stringifiedActivityTypes);
    const url = '/activities/dates';
    return this.httpClient.get<ActivitiesByDateRangeDto>(url, { params });
  }

  getActivityFilters(): Observable<ActivityFacet[]> {
    const url = '/search/facets/courseHistory';
    return this.httpClient.get<ActivityFacet[]>(url);
  }

  getActivityDetailByDate(date: Date, personId: number): Observable<ActivityHistoryDetail[]> {
    const stringDate = this.datePipe.transform(date, 'MMddyyyy');
    const params: HttpParams = new HttpParams().set('personId', personId.toString()).set('date', stringDate);
    const url = '/activities/details';
    return this.httpClient.get<ActivityHistoryDetail[]>(url, { params });
  }
}



// WEBPACK FOOTER //
// ./ts/app/activity-calendar/activity-calendar-service/activity-calendar.service.ts